import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

// Actions
import { getEmployees, setChangeNewEmployee, setEditEmployee } from '../../actions/users';
import { getEmployeeImgs, setIdUserDeleteA, setUserEditing } from '../../actions/stepsUser';
import { resetAll } from '../../actions/global';

// Components
import BannerCreateUser from '../../components/Banners/BannerCreateUser/BannerCreateUser';
import CreateUser from '../../components/Modals/ModalsWithArrows/User/CreateUser';
import UserComponent from '../../components/Users/UserComponent/UserComponent';
import DeleteModal from '../../components/Modals/DeleteHourModal/DeleteModal';
import WelcomeModal from '../../components/Modals/WelcomeModal/WelcomeModal';

// Icons
import { UserPlus, Users } from 'lucide-react';

// Kit
import { PageHeader, EmptyState, Button } from '@/components/ui';

// CSS
import LayoutPages from '../../layout/LayoutPages';

const MyUsers = (props) => {

    // Actions
    const { setUserEditing, resetAll, getEmployeesA, setChangeNewEmployee, setEditEmployee, getEmployeeImgs } = props;

    // States
    const { endTutorial, employees, newUser, editUser } = props;

    const [showWelcomeModal, setShowWelcomeModal] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const handleShowDeleteModal = () => {
        setShowModal( !showModal );
    }

    const handleCloseWelcome = () => {
        setShowWelcomeModal( !showWelcomeModal );
    }

    const handleCreateUser = () => {
        setUserEditing({
            userEditing: false,
            userUid: ''
        });
        
        resetAll();
    }

    useEffect(() => {
        getEmployeeImgs();
        getEmployeesA();
    }, []);

    const handleCloseBannerNew = () => {
        setChangeNewEmployee({
            newUser: false
        });
    }

    const handleCloseBannerEdit = () => {
        setEditEmployee({
            editUser: false
        })
    }

    return (
        <LayoutPages>
            <div className="mx-auto w-full max-w-5xl text-left">
                <div className="relative">
                    <PageHeader
                        eyebrow="Asesores"
                        title="Mis asesores"
                        subtitle="Creá y editá los asesores que van a estar disponibles en tu chat."
                        actions={
                            <Button asChild className="no-underline">
                                <Link to='/createUser' onClick={ handleCreateUser }>
                                    <UserPlus />
                                    Agregar asesor
                                </Link>
                            </Button>
                        }
                    />
                    { (endTutorial && employees.length === 0) && <CreateUser/> }
                </div>
                {
                    employees.length === 0
                        ? (
                            <EmptyState
                                icon={ Users }
                                title="Todavía no tenés asesores"
                                description="Creá tu primer asesor para que esté disponible en el chat de tu tienda."
                                action={
                                    <Button asChild>
                                        <Link to='/createUser' onClick={ handleCreateUser }>
                                            <UserPlus />
                                            Agregar asesor
                                        </Link>
                                    </Button>
                                }
                            />
                        )
                        : (
                            <div className="flex flex-col gap-3">
                                {
                                    employees.map((employee, index) => (
                                        <UserComponent
                                            key={ index }
                                            id={ index }
                                            onDelete={ handleShowDeleteModal }
                                            {...employee}
                                        />
                                    ))
                                }
                            </div>
                        )
                }
                <DeleteModal
                    open={ showModal }
                    handleClose={ handleShowDeleteModal }
                    type={ 'users' }
                />
                { endTutorial && <WelcomeModal open={showWelcomeModal} handleClose={ handleCloseWelcome }/> }
                {
                    editUser && 
                        <BannerCreateUser 
                            open={ editUser } 
                            success={ editUser } 
                            handleClose={ handleCloseBannerEdit }
                            type={ 'edit' }
                            error={ false } 
                        />
                }
                {
                    newUser && 
                        <BannerCreateUser 
                            open={ newUser } 
                            success={ newUser } 
                            handleClose={ handleCloseBannerNew }
                            type={ 'congrats' }
                            error={ false } 
                        />
                }
            </div>
        </LayoutPages>
    )
}

const mapStateToProps = state => {
    return {
        employees: state.employees.employees,
        endTutorial: state.auth.endTutorial,
        editUser: state.employees.editUser,
        newUser: state.employees.newUser,
        users: state.stepsUser.users,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setUserEditing: ({ userEditing, userUid }) => dispatch(setUserEditing({ userEditing, userUid })),
        setChangeNewEmployee: (data) => dispatch( setChangeNewEmployee(data) ),
        setIdUserDeleteA: (value) => dispatch(setIdUserDeleteA(value)),
        setEditEmployee: (value) => dispatch(setEditEmployee(value)),
        getEmployeeImgs: () => dispatch(getEmployeeImgs()),
        getEmployeesA: () => dispatch( getEmployees() ),
        resetAll: () => dispatch(resetAll()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyUsers);